export default {
  firstName: "Prénom",
  lastName: "Nom",
  male: "Homme",
  female: "Femme",
  favoriteColor: "Couleur préférée",
  employed: "Employé",
  notes: "Notes",
  email: 'Adresse courriel',
  password: 'Mot de passe',
  oldPassword: 'Mot de passe actuel',
  newPassword: 'Nouveau mot de passe',
  confirmPassword: 'Confirmez le mot de passe',
  confirmNewPassword: 'Confirm new password',
  rememberMe: 'Se souvenir de moi',
  keywords: 'Mots-clés',
  validation: {
    emailRequired: 'Un adresse courriel est requise.',
    passwordsMustMatch: 'Les mots de passes doivent correspondre.',
  },

  newsletter: {
    email: 'Adresse courriel',
    schoolLevels: 'Niveau scolaire',
    submit: 'Abonnez-vous',
  },
};



// WEBPACK FOOTER //
// ./src/config/locales/fr/form.js